import { RootState } from 'Data/Redux';
import { hasValue } from 'Lib/Any';
import deepEquals from 'Lib/Object/deepEquals';
import { toTitleCase } from 'Lib/String';
import React from 'react';
import { useSelector } from 'react-redux';
import { TextOutput, Dialog, Field } from '../../Core';
import { withInjectedProps } from '../../Core/InjectedPropsContext';
import EquipmentTypes from '../equipmentTypes';
import './InterfaceConnectingDialog.scss';

/**
 * A dialog that gets displayed when connecting to a port for interfacing
 * (to show relevant details)
 */
let InterfaceConnectingDialog: React.FC = () => {
  const isConnecting: boolean = useSelector((state: RootState) => state.equipmentInterfacing.isConnecting);

  const connectionDetails = useSelector((state: RootState) => state.equipmentInterfacing.connectionDetails, deepEquals);

  const equipmentName =
    (hasValue(connectionDetails?.equipmentData?.type) &&
      EquipmentTypes[connectionDetails!.equipmentData.type]?.name!.toLowerCase()) ??
    'unknown equipment type';

  return (
    <Dialog className="InterfaceConnectingDialog" visible={isConnecting} title="Awaiting port selection..." width={400}>
      <div className="InterfaceConnectingDialog-Content">
        Select a port to connect with {equipmentName} {connectionDetails?.equipmentData.code}
        <div>
          <h1>Connection Settings</h1>
          <Field label="Baud Rate" input={<TextOutput />} value={connectionDetails?.options.baudRate} horizontal />
          <Field
            label="Parity"
            input={<TextOutput />}
            value={toTitleCase(connectionDetails?.options?.parity)}
            horizontal
          />
          <Field label="Data Bits" input={<TextOutput />} value={connectionDetails?.options?.dataBits} horizontal />
          <Field label="Stop Bits" input={<TextOutput />} value={connectionDetails?.options?.stopBits} horizontal />
          <Field
            label="Expected COM Port"
            input={<TextOutput />}
            value={connectionDetails?.equipmentData.expectedComPort}
            horizontal
          />
        </div>
      </div>
    </Dialog>
  );
};

InterfaceConnectingDialog = withInjectedProps(InterfaceConnectingDialog);

export { InterfaceConnectingDialog };
export default InterfaceConnectingDialog;
